import { Module } from 'vuex';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';
import { ProductionState } from './types';

const productionModule: Module<ProductionState, any> = {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};

export default productionModule;
